import React, { useContext, useState } from "react";
import { AuthContext } from "../../Context/Auth";
import { Instance } from "../../Context/axiosContext";
import { Box, Modal, OutlinedInput, Typography } from "@material-ui/core";
import { RestaurantContext } from "../../Context/RestaurantData";
import { PrimaryButton } from "../../Shared/Buttons";

function LockModal({ getRestStatus }) {
  const axiosInstance = Instance();
  let url = process.env.REACT_APP_API_URL;
  const { setLockModal, lockModal, user } = useContext(AuthContext);
  const { restaurantData } = useContext(RestaurantContext);
  const [err, setErr] = useState(false);
  const [inp, setInp] = useState("");
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setLockModal(false);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "20px",
    boxShadow: 24,
    p: 4,
  };
  async function changeLockStatus(x) {
    setLoading(true);
    await axiosInstance
      .get(`locksetting?lockstatus=${x}`)
      .then(({ data }) => {
        console.log(data);
        setLoading(false);
        getRestStatus();
      })
      .catch((e) => {
        console.log("error", e.message);
        setLoading(false);
      });
  }
  async function handleSubmit() {
    if (inp.toLowerCase().trim() === restaurantData.slug.toLowerCase()) {
      await changeLockStatus(false);
      setInp("");
      handleClose();
    } else {
      setErr(true);
    }
  }
  return (
    <Modal open={lockModal} onClose={handleClose}>
      <Box sx={style}>
        <Typography
          style={{ marginBottom: "20px" }}
          variant="h6"
          component="h2"
          key={"lockTitle"}
        >
          To Unlock Write "{restaurantData.slug}"
        </Typography>
        {err && (
          <Typography
            style={{ color: "red", marginTop: "20px" }}
            key={"LockStatus"}
          >
            Incorrect slug name
          </Typography>
        )}
        <OutlinedInput
          onKeyUp={(e) => {
            if (e.code === "Enter") {
              handleSubmit();
            }
          }}
          onChange={(e) => {
            setInp(e.target.value);
            setErr(false);
          }}
          style={{ width: "100%" }}
          placeholder="Write Slug Name Here"
        />
        <Box
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "15px",
          }}
        >
          {loading ? (
            <PrimaryButton type="warning" disabled variant="contained">
              Loading...
            </PrimaryButton>
          ) : (
            <PrimaryButton
              type="success"
              loading={true}
              handleClick={handleSubmit}
              variant="contained"
            >
              Submit
            </PrimaryButton>
          )}
        </Box>
      </Box>
    </Modal>
  );
}

export default LockModal;
